<script>
import Card from '@/components(new)/UI/Cards/Card/Card.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import { irrigacao } from '@/libs/models/cadastro/praticas/genericos'
import Safras from '@/components(new)/UI/Forms/FormulariosProntos/Safras/Safras.vue'
import PrevisaoColheita from '@/components(new)/UI/Forms/FormulariosProntos/PrevisaoColheita/PrevisaoColheita.vue'
import Bioinsumos from '@/components(new)/UI/Forms/FormulariosProntos/Bioinsumos/Bioinsumos.vue'
import Financiamentos from '@/components(new)/UI/Forms/FormulariosProntos/Financiamentos/Financiamentos.vue'
import Irrigacao from '@/components(new)/UI/Forms/FormulariosProntos/Irrigacao/Irrigacao.vue'
import { v4 as uuidv4 } from 'uuid'
import { formataStringYearMonthToBr } from '@/libs/utils/functions/dataFormater'
import { safrasValidation, previsaoColheitaValidation, bioinsumosValidation,
  irrigacaoValidation, financiamentosValidation } from '@/libs/utils/validations/praticasValidations'

export default {
  components: {
    Card,
    Label,
    Safras,
    PrevisaoColheita,
    Bioinsumos,
    Financiamentos,
    Irrigacao
  },
  props: {
    pratica: {
      type: Array,
      required: true
    },
    observer: {
      required: true
    }
  },
  data () {
    return {
      nomeAba: 'Práticas',
      isEdit: false,
      forms: {
        ano: '',
        areaDestinada: '',
        dataInicio: '',
        previsoesColheitaProdutividade: [],
        possuiIrrigacao: '',
        irrigacao: {...irrigacao},
        utilizaBioinsumos: '',
        bioinsumos: null,
        financiamentos: [],
        outroFinanciamento: '',
        descricao: '',
        id: uuidv4()
      }
    }
  },
  computed: {
    // valida todos cadastros para cadastrar mais um card
    validationDisableButton () {
      const forms = this.forms
      return safrasValidation(forms.ano, forms.areaDestinada, forms.dataInicio) ||
      previsaoColheitaValidation(forms.previsoesColheitaProdutividade) ||
      bioinsumosValidation(forms.utilizaBioinsumos, forms.bioinsumos) ||
      irrigacaoValidation(forms.possuiIrrigacao, forms.irrigacao) ||
      financiamentosValidation(forms.financiamentos, forms.outroFinanciamento)
    }
  },
  methods: {
    btnAdicionar () {
      this.isEdit = false
      this.pratica.push(this.forms)
      this.forms = {
        ano: '',
        areaDestinada: '',
        dataInicio: '',
        previsoesColheitaProdutividade: [],
        possuiIrrigacao: '',
        irrigacao: {...irrigacao},
        utilizaBioinsumos: '',
        bioinsumos: null,
        financiamentos: [],
        outroFinanciamento: '',
        descricao: '',
        id: uuidv4()
      }
    },
    editarPratica (pratica, index) {
      this.forms = pratica
      this.isEdit = true
      this.pratica.splice(index, 1)
    },
    removerPratica (index) { this.pratica.splice(index, 1) },
    safrasValidation,
    previsaoColheitaValidation,
    formataStringYearMonthToBr,
    bioinsumosValidation,
    irrigacaoValidation,
    financiamentosValidation
  }
}
</script>

<template>
  <div>
    <!-- Formulários -->
    <Safras
      :nomeAba="nomeAba"
      :anoSafra.sync="forms.ano"
      :areaDestinada.sync="forms.areaDestinada"
      :dataInicio.sync="forms.dataInicio"
      :praticasArray="pratica"
    />

    <PrevisaoColheita
      :nomeAba="nomeAba"
      :pratica="forms"
      :praticasArray="pratica"
    />

    <Bioinsumos
      :nomeAba="nomeAba"
      :pratica="forms"
      :praticasArray="pratica"
    />

    <Irrigacao
      :nomeAba="nomeAba"
      :pratica="forms"
      :praticasArray="pratica"
    />

    <Financiamentos
      :nomeAba="nomeAba"
      :pratica="forms"
      :praticasArray="pratica"
    />

    <el-row>
      <validation-provider>
        <el-col :span="23">
          <Label label="Descrição" :obrigatorio="false" />
          <el-input
            name="Descrição" v-model="forms.descricao"
            class="input" type="textarea"
            maxlength="500"
            show-word-limit
          />
        </el-col>
      </validation-provider>
    </el-row>

    <!-- Botão de adicionar e card-->
    <div class="flex-end mt-3 mb-3">
      <el-button :disabled="validationDisableButton" round type="primary" @click="btnAdicionar">
         {{ isEdit ? 'Salvar' : 'Adicionar'}} Ano/Safra
      </el-button>
    </div>

    <el-row :gutter="20">
      <div class="flex-wrapper row">
        <Card
          v-for="(item, index) in pratica"
          :key="index"
          :objeto="{
            ano: item.ano,
            areaDestinada: item.areaDestinada + ' ha',
            dataInicio: formataStringYearMonthToBr(item.dataInicio)
          }"
          :titulo="`Ano safra: ${item.ano || ''}`"
          :deletar="() => removerPratica(index)"
          :editar="() => editarPratica(item, index)"
        />
      </div>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/SPDG/SPDG.vue